export default {
  "home": "HOME",
  "news": "NEWS",
  "community": "COMMUNITY",
  "character": "CHARACTERS",
  "world": "WORLD",
  "features": "FEATURES",
  "topUp": "TOP UP",
  "customerService": "CUSTOMER",
  "download": "DOWNLOAD",
  "moreDownload": "More download methods",
  "screenshot": "SCREENSHOT",
  "video": "CINEMATIC",
  "poster": "POSTER",
  "downloadGame": "DOWNLOAD",
  "scan": "Scan QR code to download",
  "prev": "Previous",
  "next": "Next",
  "latest": "LATEST",
  "moreNews": "INFORMATION",
  "fwtk": "TERMS OF SERVICE",
  "yszc": "PRIVACY POLICY",
  "noContent": "No content yet",
  "goPay": "GO NOW",
  "payGuide": "LEARN MORE",
  "stayTurn": "Stay tuned!",
  "hero1": "Giganotosaurus",
  "hero1_text": "Giganotosaurus was a huge meat-eating dinosaur that lived in South America around 100 million years ago. It was one of the largest carnivorous dinosaurs, with a long, narrow skull and sharp teeth. It likely hunted large plant-eating dinosaurs.",
  "hero2": "Triceratops",
  "hero2_text": 'Triceratops is a genus of large herbivorous dinosaur that lived during the Late Cretaceous period, about 68-66 million years ago. Triceratops had a massive skull with three horns and a bony frill on the back of its head, which likely served as a defense against predators.',
  "hero3": "Pyroraptor",
  "hero3_text": "Pyroraptor is a small theropod dinosaur that lived in the Late Cretaceous period, around 70 million years ago. It was fast and agile, which made them one of most dangerous predators.",
  "hero4": "Desert Velociraptor",
  "hero4_text": "Some velociraptors live in the desert areas. When faced with one of those larger preys, these smart hunters would work as a team to take it down.A lot of humans tried to tame some of them, but no one has succeeded yet. Perhaps they are not meant to be tamed at all.",
  "hero5": "Velociraptor",
  "hero5_text": 'Velociraptor is a genus of small theropod dinosaur that lived during the Late Cretaceous period, about 75-71 million years ago. It was a fast and agile predator. Velociraptor had a distinctive sickle-shaped claw on its hind foot, which it likely used to slash at its prey.',
  "roleMainTitle": "SAURPET",
  "roleSubTitle": "",
  "specialMainTitle": "Gallery",
  "back": "Back",
  "slogan": "Primal Conquest: Dino Era",
  strategy: "GUIDE",
  notice: "ANNOUNCEMENT",
  activity: "EVENT",
}
